
namespace TabAurous.Reports {
    import fld = TabAurous.SalesOrder.SalesOrderItemsRow.Fields; 
    
    @Serenity.Decorators.registerClass()
    export class OrderStatusGrid extends Serenity.EntityGrid<TabAurous.SalesOrder.SalesOrderItemsRow, any> {
        protected getColumnsKey() { return 'SalesOrder.OrderStatus'; }
        protected getDialogType() { return TabAurous.SalesOrder.SalesOrderItemsDialog; }
        protected getIdProperty() { return TabAurous.SalesOrder.SalesOrderItemsRow.idProperty; }
        protected getInsertPermission() { return TabAurous.SalesOrder.SalesOrderItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return TabAurous.SalesOrder.SalesOrderItemsRow.localTextPrefix; }
        protected getService() { return TabAurous.SalesOrder.OrderStatusService.baseUrl; }

        private chartContainer: JQuery;
        private chartPanel: Reports.LineChartPanel;
        constructor(container: JQuery) {
            super(container);

            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.FinancialYearRow.lookupKey,
                    multiple: true

                },
                field: 'FinancialYearId',
                title: 'Year',
                handler: w => {
                    var temp= [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).FinancialYearIds = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    }
                },
                
                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.CompanyRow.lookupKey,
                    multiple: true

                },
                field: 'CompanyId',
                title: 'Company',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).CompanyIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: "VendorLKUP",
                    multiple: true

                },
                field: 'PartyId',
                title: 'Party',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).VendorIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });
          

            return filters;
        }

        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();


            // adding a specific css class to UnitPrice column, 
            // to be able to format cell with a different background
            Q.first(columns, x => x.field == fld.Status).cssClass += " col-status";

            return columns;
        }
        protected getItemCssClass(item: SalesOrder.SalesOrderItemsRow, index: number): string {
            let klass: string = "";

            if (item.Status == "Closed") {
                klass += " discontinued";
                klass += " closedorder";
            } else if (item.Status == "Open") {
                klass += " discontinued";
                klass += " openorder";
            } else if (item.Status == "In Process") {
                klass += " discontinued";
                klass += " inprocess";
            }

            
            return Q.trimToNull(klass);
        } 

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
            this.view.setGrouping([{

                getter: 'LedgerName',
                displayTotalsRow: false,
            }])
            return grid;
        }

        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            //buttons.push({

            //    title: 'Print',
            //    icon: 'fa fa-print text-blue',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {
                    
            //        Common.ReportHelper.execute({
            //            reportKey: 'Reports.ApprovalRegister',
            //            params: {
            //                CompanyIds: this.view.params.CompanyIds,
            //                FinIds: this.view.params.FinancialYearIds,
            //                VendorIds: this.view.params.VendorIds,
            //                date:this.view.params.Criteria
            //            }
            //        });
            //    }
            //});
            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                title: "Print",
                reportTitle: "Sales Order Status",
                onViewSubmit: () => this.onViewSubmit()
            }));
            return buttons;
        }
    }
}